module.exports = __webpack_public_path__ + "static/img/sph_axgp.f8ffcd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sph_axgp.png
// module id = 55yn
// module chunks = 130